/* ========================================================================
 * FD:          FD
 * Child:       CONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * button
 * ======================================================================== 
 * 1/2/2017: creation
*/

FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};



    /* ========================================================================
     *  private vars
     *  use no-tabcount class to not count in cell total count
     * ========================================================================
    */

    //  defaults
    var NAMESPACE = me.getUID('TABLE_');
    var TABLEID = '#MAIN';

    var table = null;
    var cellList = [];
    var cellInRow = 0;
    var min = 0;
    var max = 0;
    var currentCell = 2;


    var lastElem = null;

    var key = {
        DOWN: 40,
        UP: 38,
        RIGHT: 39,
        LEFT: 37,
        TAB: 9,
        ENTER: 13,
    }
    
    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    //  set events
    function setEvents() {
        table.off('keydown.' + NAMESPACE);
        table.on('keydown.' + NAMESPACE, function (event) {
            var tempCell;
            var keyCode = event.keyCode || event.which;

            if (event.shiftKey && keyCode == key.TAB) {
                tempCell = (currentCell - 1);

                if (tempCell >= min && tempCell <= max) {
                    currentCell = tempCell;
                    onFocus();

                    return false;
                }
            }
            //console.log(keyCode)
            if (keyCode == key.DOWN /*|| keyCode == key.ENTER*/) {
                tempCell = (currentCell + cellInRow);

                if (tempCell >= min && tempCell < max) {
                    currentCell = tempCell;
                    onFocus();
                }
            }

            if (keyCode == key.UP) {
                tempCell = (currentCell - cellInRow);

                if (tempCell >= min && tempCell <= max) {
                    currentCell = tempCell;
                    onFocus();
                }
            }

            if (keyCode == key.RIGHT || keyCode == key.TAB) {
                tempCell = (currentCell + 1);

                if (tempCell >= min && tempCell < max) {
                    currentCell = tempCell;
                    onFocus();

                    return false;
                }
            }

            if (keyCode == key.LEFT) {
                tempCell = (currentCell - 1);

                if (tempCell >= min && tempCell <= max) {
                    currentCell = tempCell;
                    onFocus();

                    return false;
                }
            }
        });

        table.off('click.' + NAMESPACE);
        table.on('click.' + NAMESPACE, 'td', function (event) {
            var elem = $(this);
            var id = elem.attr('id');

            for (var i = 0, len = cellList.length; i < len; i++) {
                var d = cellList[i];
                if (d.id === id) {
                    currentCell = i;
                    onFocus();
                    break;
                }
            }
        });

        $(document).on('click.tablenremovehl', function (event) {
            var target = $(event.target);

            if (!target.parents(TABLEID).length > 0) removeHighLight();
        });
    }


    //  set table tab
    function setTableTab(container, startCell) {
        //  set list
        if (container !== null) {
            if (typeof container === 'string') table = $(container);
        } else {
            table = $(container);
        }

        //  bail
        if (table.length === 0) return;

        cellList = [];
        var trList = table.find('tr').not('.topheader').not('.footer').not('.border-row');
        var tempCellList = trList.find('td').not('.no-tabcount').not('.no-select');

        //console.log(tempCellList.length)
        if (tempCellList.length === 0) return;

        tempCellList.each(function () {
            var e = $(this);
            var id = me.getUID('C_');
            e.attr('id', id);
            var cell = {
                id: id,
                cell: e
            };
            cellList.push(cell);
        });

        max = cellList.length;

        //  change to grab second tr on main table
        cellInRow = table.find('tr:nth-child(2)').children('td').not('.no-tabcount').not('.no-select').length;  // not zero based

        //  might have a spacer/header row try row 3
        if (cellInRow === 0) cellInRow = table.find('tr:nth-child(3)').children('td').not('.no-tabcount').not('.no-select').length;

        //  start cell
        if (startCell !== null && startCell !== '') currentCell = startCell;

        onFocus();

        setEvents();
    }


    //  on focus
    function onFocus() {
        if (cellList.length === 0) return;

        if (lastElem !== null) $(lastElem).children().removeClass('in');

        //  remove other input highlights (used in part forecast top row)
        $('[data-inputhighlight="true"]').removeClass('in');

        if (cellList.length <= currentCell) currentCell = 0;

        var elemCheck = $('#' + cellList[currentCell].id);
        if (elemCheck.length === 0) currentCell = 0;

        var elem = $('#' + cellList[currentCell].id);
        table.find('tr').removeClass('highlight-child-withborder');
        elem.parent('tr').addClass('highlight-child-withborder');

        lastElem = '#' + cellList[currentCell].id;

        if (elem.hasClass('no-select')) return;

        elem.children().addClass('in');
        if (elem.children('input').length > 0) {
            var e = elem.children('input').first();
            if (e.is(":focus")) return;
            e.focus();
        }
    }


    //  remove table highlight
    function removeHighLight() {
        table.find('tr').removeClass('highlight-child-withborder');
        if (lastElem !== null) $(lastElem).children().removeClass('in');
    }

    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set tabletab
    child.setTableTab = function (container, startCell) {
        if (lastElem !== null) $(lastElem).children().removeClass('in');
        setTableTab(container, startCell);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));